module.exports = __webpack_public_path__ + "img/mizutamari-cut-02.70994a69.jpg";